import orgServices from '../../../../services/notisphere/organization'
export default {
    name: 'Step0BasicInfo',
    props: {
        organizationId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            info: null,
            suppliers: [],
        }
    },
    created() {
        this.getSupplierList()
        this.getProviderContactInfo()
    },
    methods: {
        getSupplierList() {
            orgServices.GetOrganizationListByType('SUPPLIER').then(resp => {
                if (!resp.error) {
                    this.suppliers = resp.data.d.map((item) => item.name)
                }
            })
        },
        getProviderContactInfo() {
            orgServices.getProvider(this.organizationId).then(resp => {
                if(!resp.error) {
                    // const data = resp.data.d
                    const data = {
                        name: resp.data.d.name || '',
                        address: resp.data.d.add1 || '',
                        domains: resp.data.d.domains || [''],
                        supplier: resp.data.d.referring_supplier || '',
                        sourcing_indicator: resp.data.d.sourcing_indicator || 'Notisphere',
                        centralized_intake: resp.data.d.is_centralized_setting_enabled || false,
                        centralized_intake_email: resp.data.d.centralized_email || ''
                    }
                    this.info = data
                }
            })
        },
        removeDomain(index) {
            this.info.domains.splice(index, 1)
        },
        addDomain() {
            this.info.domains.push('')
        },
        save() {
            this.info.centralized_intake_email.split('@')[1]
            if(this.info.domains.length === 0) {
                this._showToast('Domains list cannot be empty', { variant: 'danger' })
                return null
            }
            if(this.info.centralized_intake_email && !this.info.domains.includes(this.info.centralized_intake_email.split('@')[1])) {
                this._showToast('Email address is not valid to your organization', { variant: 'danger' })
                return null
            }
            return new Promise((resolve, reject) => {
                this.$refs['observer'].validate().then(isValid => {
                    if (isValid) {
                        const payload = {
                            organizationId: this.organizationId,
                            name: this.info.name,
                            address: this.info.address,
                            domains: this.info.domains,
                            supplier: this.info.supplier,
                            sourcing_Indicator: this.info.sourcing_indicator,
                            AllowCentralizedIntake: this.info.centralized_intake,
                            CentralizedEmail: this.info.centralized_intake_email
                        }
                        orgServices.addProviderContactInfoStep0(payload).then(resp => {
                            if (!resp.error) {
                                resolve(resp.data)
                            } else {
                                reject(resp.error)
                            }
                        })
                    }
                    else {
                        reject('Invalid step 0')
                    }
                })
            })
        }
    },
}